// extracted by mini-css-extract-plugin
export default {"invest-component":"invest_invest-component__X7vDl","loading":"invest_loading__znjpC"};